import { MEASURESTAT } from "../../actions/portal/";

export default function(state = false, action) {
  switch (action.type) {
    case MEASURESTAT:
      return action.payload;
    default:
  }

  return state;
}
